// Services
import { apiServices } from "@core/services/appService";

// Redux
import { setStatusSpinner } from "@core/redux/actions/app/spinner";
import { setDataAlert } from "@core/redux/actions/app/alert";

// @utility
import alertText from "@utility/app/alertText";

const LOAD_LOTTERY_INFO = "app/lottery/LOAD_LOTTERY_INFO";
const LOAD_LOTTERY_INFO_RATE = "app/lottery/LOAD_LOTTERY_INFO_RATE";
const LOAD_LOTTERY_INFO_BONUS = "app/lottery/LOAD_LOTTERY_INFO_BONUS";
const SET_LOTTERY_CODE = "app/lottery/SET_LOTTERY_CODE";
const SET_LOTTERY_ROUND_CODE = "app/lottery/SET_LOTTERY_ROUND_CODE";
const LOAD_LOTTERY_RATE_CONDITION = "app/lottery/LOAD_LOTTERY_RATE_CONDITION";
const SET_LOTTERY_TYPE = "app/lottery/SET_LOTTERY_TYPE";
const SET_LOTTERY_SET_NUMBER_DATA = "app/lottery/SET_LOTTERY_SET_NUMBER_DATA";
const SET_LOTTERY_SET_NUMBER_DETAIL_DATA = "app/lottery/SET_LOTTERY_SET_NUMBER_DETAIL_DATA";

const cutDuplicateObj = (dataCode, lottoryData) => {
    let dataArrNew = lottoryData.filter((item) => item.key === dataCode);

    if (dataArrNew.length > 1) {
        let indexLast = (dataArrNew.length - 1);
        let dataArr = [dataArrNew[indexLast]];
        let dataNotDuplicate = lottoryData.filter((item) => item.key !== dataCode);

        return [...dataNotDuplicate, ...dataArr];
    }

    return lottoryData;
};

function setLotteryCode(data) {
    return dispatch => {
        dispatch({
            type: SET_LOTTERY_CODE,
            payload: {
                items: data
            }
        })
    }
}

function setLotteryRoundCode(data) {
    return dispatch => {
        dispatch({
            type: SET_LOTTERY_ROUND_CODE,
            payload: {
                items: data
            }
        })
    }
}

function setLotteryInfo(data) {
    return dispatch => {
        dispatch({
            type: LOAD_LOTTERY_INFO,
            payload: {
                items: data
            }
        })
    }
}

function loadLotteryInfo(dataCode, reduxLotteryInfo, gotoPage, roundCode) {
    return dispatch => {
        if (!reduxLotteryInfo) {
            reduxLotteryInfo = [];
        }

        apiServices({}, "get", `/customer/lottery/info-cache/${dataCode}/${roundCode}/${process.env.REACT_APP_DEFAULT_AGENT_CODE}`).then((data) => {
            const { code: statusCode, result } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {
                let dataObj = { key: dataCode, result: result === null ? [] : result };

                dispatch({
                    type: LOAD_LOTTERY_INFO,
                    payload: {
                        items: cutDuplicateObj(dataCode, [...reduxLotteryInfo, dataObj])
                    }
                })
            }
            else {
                dispatch({
                    type: LOAD_LOTTERY_INFO,
                    payload: {
                        items: null
                    }
                });

                if (gotoPage) {
                    gotoPage("/lottery");
                }
            }
        });
    }
}

function loadLotteryInfoRate(dataCode, roundCode) {
    return dispatch => {
        apiServices({}, "get", `/customer/lottery-v4/info-rate/${dataCode}/${roundCode}`).then((data) => {
            const { code: statusCode, result } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {
                dispatch({
                    type: LOAD_LOTTERY_INFO_RATE,
                    payload: {
                        items: result
                    }
                })
            }
            else {
                dispatch({
                    type: LOAD_LOTTERY_INFO_RATE,
                    payload: {
                        items: null
                    }
                });
            }
        });
    }
}

function loadLotteryInfoBonus(dataCode, roundCode) {
    return dispatch => {
        apiServices({}, "get", `/customer/lottery/info-bonus/${dataCode}/${roundCode}`).then((data) => {
            const { code: statusCode, result } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {
                dispatch({
                    type: LOAD_LOTTERY_INFO_BONUS,
                    payload: {
                        items: result
                    }
                })
            }
            else {
                dispatch({
                    type: LOAD_LOTTERY_INFO_BONUS,
                    payload: {
                        items: null
                    }
                });
            }
        });
    }
}

function loadLotteryRateAndCondition() {
    return dispatch => {
        apiServices({}, "get", `/general/lottery/rate-condition-cache/${process.env.REACT_APP_DEFAULT_AGENT_CODE}`).then((data) => {
            const { code: statusCode, result } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {
                dispatch({
                    type: LOAD_LOTTERY_RATE_CONDITION,
                    payload: {
                        items: result
                    }
                })
            }
            else {
                dispatch({
                    type: LOAD_LOTTERY_RATE_CONDITION,
                    payload: {
                        items: null
                    }
                });
            }
        });
    }
}

function loadLotteryType() {
    return dispatch => {
        dispatch(setStatusSpinner({ status: true, textProcess: null }));

        apiServices({}, "get", `/general/lottery/type-cache/${process.env.REACT_APP_DEFAULT_AGENT_CODE}`).then((data) => {
            dispatch(setStatusSpinner({ status: false, textProcess: null }));
            const statusCode = data.code;

            if (statusCode === 200 || statusCode === 0) {
                const result = data.result;

                dispatch({
                    type: SET_LOTTERY_TYPE,
                    payload: {
                        items: result
                    }
                })
            }
            else {
                dispatch({
                    type: SET_LOTTERY_TYPE,
                    payload: {
                        items: null
                    }
                })
            }
        });
    }
}

function loadLotterySetNumberData(dataObj, hideProcessing) {
    return dispatch => {
        if (!hideProcessing) {
            dispatch(setStatusSpinner({ status: true, textProcess: null }));
        }

        dispatch({
            type: SET_LOTTERY_SET_NUMBER_DATA,
            payload: {
                items: null
            }
        });

        apiServices(dataObj, "post", "/customer/lottery/ticket-set", "", "application/json").then((data) => {
            dispatch(setStatusSpinner({ status: false, textProcess: null }));
            const statusCode = data.code;

            if (statusCode === 200 || statusCode === 0) {
                const result = data.result;

                dispatch({
                    type: SET_LOTTERY_SET_NUMBER_DATA,
                    payload: {
                        items: result
                    }
                });
            }
            else {
                dispatch({
                    type: SET_LOTTERY_SET_NUMBER_DATA,
                    payload: {
                        items: null
                    }
                });
            }
        });
    }
}

function loadLotterySetNumberDetailData(dataObj) {
    return dispatch => {
        dispatch(setStatusSpinner({ status: true, textProcess: null }));

        dispatch({
            type: SET_LOTTERY_SET_NUMBER_DETAIL_DATA,
            payload: {
                items: null
            }
        });

        apiServices(dataObj, "post", "/customer/lottery/ticket-set/number", "", "application/json").then((data) => {
            dispatch(setStatusSpinner({ status: false, textProcess: null }));
            const statusCode = data.code;

            if (statusCode === 200 || statusCode === 0) {
                const result = data.result;

                dispatch({
                    type: SET_LOTTERY_SET_NUMBER_DETAIL_DATA,
                    payload: {
                        items: result
                    }
                });
            }
            else {
                dispatch({
                    type: SET_LOTTERY_SET_NUMBER_DETAIL_DATA,
                    payload: {
                        items: null
                    }
                });
            }
        });
    }
}

function createLotterySetNumber(dataObj, gotoPage, typeNumber) {
    return dispatch => {
        dispatch(setStatusSpinner({ status: true, textProcess: "กำลังทำรายการ กรุณารอสักครู่..." }));

        apiServices(dataObj, "post", "/customer/lottery/ticket-set/create", "", "application/json").then((data) => {
            dispatch(setStatusSpinner({ status: false, textProcess: null }));
            const statusCode = data.code;

            if (statusCode === 200 || statusCode === 0) {
                dispatch(setDataAlert({
                    type: "success",
                    title: "แจ้งเตือน",
                    text: typeNumber === "order" ? "บันทึกโพยสำเร็จ !" : "สร้างเลขชุดสำเร็จ !",
                    action: true,
                    redirect: null,
                    show: true,
                    buttonText: "ตกลง"
                }));

                if (gotoPage) {
                    if (typeNumber === "order") {
                        gotoPage("", "goBack");
                    }
                    else {
                        gotoPage("/lottery/set-number", "force");
                    }
                }
            }
            else {
                const snackbarJson = alertText(statusCode);

                dispatch(setDataAlert({
                    type: snackbarJson.statusAlert,
                    title: snackbarJson.titleAlert,
                    text: snackbarJson.textAlert,
                    action: true,
                    redirect: null,
                    show: true,
                    buttonText: "ตกลง"
                }));
            }
        });
    }
}

function deleteLotterySetNumber(dataObj, reloadData) {
    return dispatch => {
        dispatch(setStatusSpinner({ status: true, textProcess: "กำลังทำรายการ กรุณารอสักครู่..." }));

        apiServices(dataObj, "post", "/customer/lottery/ticket-set/delete", "", "application/json").then((data) => {
            dispatch(setStatusSpinner({ status: false, textProcess: null }));
            const statusCode = data.code;

            if (statusCode === 200 || statusCode === 0) {
                dispatch(setDataAlert({
                    type: "success",
                    title: "แจ้งเตือน",
                    text: "ลบเลขชุดสำเร็จ !",
                    action: true,
                    redirect: null,
                    show: true,
                    buttonText: "ตกลง"
                }));

                if (reloadData) {
                    reloadData();
                }
            }
            else {
                const snackbarJson = alertText(statusCode);

                dispatch(setDataAlert({
                    type: snackbarJson.statusAlert,
                    title: snackbarJson.titleAlert,
                    text: snackbarJson.textAlert,
                    action: true,
                    redirect: null,
                    show: true,
                    buttonText: "ตกลง"
                }));
            }
        });
    }
}

export {
    LOAD_LOTTERY_INFO,
    LOAD_LOTTERY_INFO_RATE,
    LOAD_LOTTERY_INFO_BONUS,
    SET_LOTTERY_CODE,
    LOAD_LOTTERY_RATE_CONDITION,
    SET_LOTTERY_TYPE,
    SET_LOTTERY_SET_NUMBER_DATA,
    SET_LOTTERY_SET_NUMBER_DETAIL_DATA,
    SET_LOTTERY_ROUND_CODE,
    setLotteryInfo,
    loadLotteryInfo,
    loadLotteryInfoRate,
    loadLotteryInfoBonus,
    setLotteryCode,
    loadLotteryRateAndCondition,
    loadLotteryType,
    createLotterySetNumber,
    loadLotterySetNumberData,
    loadLotterySetNumberDetailData,
    deleteLotterySetNumber,
    setLotteryRoundCode
}